// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-0284b5b9]{background-color:var(--color-white-dark);height:100vh;overflow:auto}.app[data-v-0284b5b9],.content[data-v-0284b5b9]{display:flex;flex-direction:column}.content[data-v-0284b5b9]{align-items:center;flex:1;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
